import {MutationTree} from 'vuex';
import {SystemUsersState} from "@/store/user_management/system_users/types";

export const mutations: MutationTree<SystemUsersState> = {
    setSystemUsers: (state, payload) => {
        state.systemUsers = payload;
    },
    pushSystemUsers(state, data) {
        state.systemUsers = state.systemUsers.concat(data);
    },
    setSystemUserItem: (state, payload) => {
        state.systemUserItem = payload;
    },
    setSystemPages: (state, data) => {
        state.systemPages = data;
    },
}
